export const editorCardClass = "panel-bg rounded-[24px] border border-border p-6 sm:p-8"
export const editorInputClass = "field-bg mt-2 h-12 w-full rounded-xl border border-border px-4 text-[13px] outline-none transition focus:border-ring focus:ring-4 focus:ring-ring/10"
export const editorHeadingClass = "font-display text-[21px] font-bold tracking-[-.035em]"
export const editorDescriptionClass = "muted mt-1 text-[13px] leading-relaxed"
